<template>
  <div>
    <PageTitle
      title="Rate Type Details"
      :backBtn="true"
      :showLoading="isLoading"
    />
    <v-container fluid class="lighten-12">
     
    </v-container>
  </div>
</template>
<script>
// import RoomProperty from "./RoomProperty.vue";
import { required, email, max } from "vee-validate/dist/rules";
import axios from "@/plugins/axios";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

// Mixins
// import Categories from "@/mixins/Categories";

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  // mixins: [Categories],
  components: {
    ValidationProvider,
    ValidationObserver,
    // RoomProperty,
  },
  data: () => ({
 
  }),
  created() {
  },
  methods: {
    
  },




};
</script>
